import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Trophy } from 'lucide-react';
import { LeafDivider, Section } from './Shared';
import { trackPixelEvent } from '../utils/metaPixel';
const checkoutUrl = 'https://latam-kit-saberes-ancestrales.impultienda.ar/checkout';
export function Pricing() {
  return <Section id="pricing" className="bg-brand-surfaceLight/60 rounded-3xl my-12 border border-brand-purple/20" data-id="element-339" data-mp="2jknsns4wrztx">
      <div className="text-center mb-8" data-id="element-340" data-mp="1vutijibz4pdd">
        <div className="inline-flex items-center gap-2 rounded-full border border-brand-gold/50 bg-brand-goldLight/30 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-brand-goldDark md:text-sm" data-id="element-341" data-mp="1rsgauodo2hdy">
          <Trophy className="h-4 w-4" data-id="element-342" data-mp="20tegfb3r6wyn" /> Oferta de lanzamiento
        </div>
        <h2 className="mt-4 text-2xl font-display font-bold text-brand-purpleDark md:text-4xl" data-id="element-343" data-mp="20v7psy5r3vac">
          UN SOLO KIT.
          TODO RESUELTO.
        </h2>
        <p className="mt-3 text-sm text-brand-text/70 md:text-base" data-id="element-344" data-mp="3c78iup9ne5vw">
          🌿 5 volúmenes principales + 3 bonus estratégicos. Acceso inmediato y de por vida.
        </p>
        <LeafDivider className="mt-6 mb-0" data-id="element-345" data-mp="4svy3wg6rew1" />
      </div>

      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-brand-purple bg-white p-6 text-center shadow-[0_0_28px_rgba(47,107,52,0.18)] md:p-9" data-id="element-346" data-mp="4rb2e3i4xpwl">
        <div className="mb-4 flex items-center justify-center gap-2 text-brand-purple" data-id="element-347" data-mp="erle1joiup9n">
          <Trophy className="h-5 w-5 fill-brand-purple" data-id="element-348" data-mp="3d9h7vfgn6c07" />
          <span className="text-xs font-bold uppercase tracking-[0.16em] md:text-sm" data-id="element-349" data-mp="3d6upslw4ke3q">Kit completo</span>
        </div>
        <h3 className="font-serif text-xl font-bold leading-tight text-brand-purpleDark md:text-3xl" data-id="element-350" data-mp="3n753s8pzhpjy">
          MEGAPACK SABERES ANCESTRALES™ EDICIÓN LATINOAMÉRICA
        </h3>
        <p className="mt-2 text-sm text-brand-text/70 md:text-base" data-id="element-351" data-mp="3rz6evrbf1a8e">
          5 Volúmenes + 3 Bonus · 390 páginas
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm font-medium leading-relaxed text-brand-purple md:text-base" data-id="element-352" data-mp="2zhkivka9si81">
          Domina la fitoterapia global, las preparaciones profesionales, el criterio clínico y la espagiria vegetal.
        </p>

        <div className="my-6 flex items-end justify-center gap-3" data-id="element-353" data-mp="2mh0a5dtnfcu9">
          <span className="pb-1 text-base text-brand-text/40 line-through md:text-lg" data-id="element-354" data-mp="316ehyhhktm7j">US$65</span>
          <span className="font-serif text-4xl font-bold leading-none text-brand-purple md:text-5xl" data-id="element-355" data-mp="2w7uu2bjfa0cj">US$15</span>
          <span className="pb-1 text-sm font-bold text-brand-purple md:text-base" data-id="element-356" data-mp="28h7bmwbvrsbq">USD</span>
        </div>
        <p className="-mt-3 mb-6 text-xs text-brand-text/60 md:text-sm" data-id="element-357" data-mp="23jp8jmkjo7bn">
          El precio se convierte automáticamente a la moneda local de tu país
        </p>

        <div className="mx-auto mb-7 grid max-w-lg gap-2 text-left text-xs text-brand-text md:grid-cols-2 md:text-sm" data-id="element-358" data-mp="2dh3f8ugo1hqr">
          {['5 volúmenes clínicos incluidos', '3 bonus listos para imprimir', 'Acceso inmediato en PDF', 'Garantía total de 7 días'].map(item => <div key={item} className="flex items-center gap-2" data-id="element-359" data-mp="3ovh2bx3lht5q">
              <CheckCircle2 className="h-4 w-4 shrink-0 text-brand-purple" data-id="element-360" data-mp="9ucs1fbaji6" />
              {item}
            </div>)}
        </div>

        <motion.a href={checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', {
        content_name: 'Megapack Saberes Ancestrales Latinoamérica',
        value: 15,
        currency: 'USD'
      })} animate={{
        scale: [1, 1.018, 1],
        y: [0, -2, 0]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.035,
        y: -2
      }} whileTap={{
        scale: 0.98
      }} className="cta-shimmer purple-gradient-bg inline-flex w-full items-center justify-center rounded-full px-6 py-4 text-sm font-bold text-white shadow-[0_0_20px_rgba(47,107,52,0.4)] md:py-5 md:text-lg" data-id="element-361" data-mp="5a9o6ng19gxi">
          🌿 → QUIERO MI MEGAPACK COMPLETO US$15
        </motion.a>
        <p className="pt-4 text-xs text-brand-text/60 md:text-sm" data-id="element-362" data-mp="16qfv39ghzebj">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳 Tarjeta y pagos locales
        </p>
      </div>
    </Section>;
}